import { render, staticRenderFns } from "./collapsible.component.vue?vue&type=template&id=5a80b77e&scoped=true&"
import script from "./collapsible.component.vue?vue&type=script&lang=js&"
export * from "./collapsible.component.vue?vue&type=script&lang=js&"
import style0 from "./collapsible.component.vue?vue&type=style&index=0&id=5a80b77e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a80b77e",
  null
  
)

export default component.exports